module.exports = __webpack_public_path__ + "img/ho-claron.58604353.jpg";